<template>
	<Container>
		<TopBar/>
		<div class="content" v-if='result.Flag'>
			<img class="img" v-if='result.Flag == 11' src="@/assets/pass.jpg">
			<img class="img" v-else src="@/assets/fail.jpg">

			<p class="title">考核評估</p>
			<div class="detail">
				<div class="score">
					<p class="value">{{result.Score}}</p>
					<p class="label">得分</p>
				</div>
				<div class="time">
					<p class="value">{{(result.LostTime / 60).toFixed(2)}}</p>
					<p class="label">用時(分鍾)</p>
				</div>
				<div class="wrong-count">
					<p class="value">{{wrongs.length}}</p>
					<p class="label">錯題</p>
				</div>
			</div>
			<div v-if='result.NeedLesson' class="need-lesson">隻要再觀看{{result.NeedLesson}}個課程就能取得達人卡咯~！</div>
		</div>
		<div class="wrong-qs" v-if='wrongs.length'>
			<div class="head"><img src="@/assets/wrong.jpg">錯題解析</div>
			<div class="qs" v-for='wrong in wrongs'>
				<p class="topic">{{wrong.QuestionType == 1 ? '[單選題]':'[多選題]'}}{{wrong.Title}}</p>
				<div class="options">
					<RadioGroup   v-if='wrong.QuestionType == 1'  vertical size='large' :value='wrong.Answer'>
						<Radio disabled v-for='option in wrong.Options' :label="option.Id+''" class='radio'>
				            <span class="option-title">&nbsp;&nbsp;{{option.Title}}</span>
				        </Radio>
					</RadioGroup>
					<CheckboxGroup  vertical v-else size='large' :value='wrong.Answer.split(",")'>
						<Checkbox disabled  v-for='option in wrong.Options' :label="option.Id+''" class='radio'>
				            <span class="option-title">&nbsp;&nbsp;{{option.Title}}</span>
				        </Checkbox><br>
					</CheckboxGroup>
				</div>
				<p class="correct">正確答案：<span>{{wrong.Options.filter(item=>item.IsRightAnswer).map(item=>item.Title).join(',')}}</span></p>
			</div>
		</div>
		<div class="bottoms">
			<div v-if='result.Flag != 11 && result.LessonCode' class="button-primary button" @click='reWatch'><span>重新觀看視頻答題</span></div>
			<a href='#/train' v-else class="button-primary button"><span>返回首頁</span></a>
			<div v-if='result.HaveCertificate' class="button-primary button" @click='showCer'><span>查看達人卡</span></div>
		</div>	
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				subjects:{},
				result:{},
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			TopBar,
		},
		computed: {
			...mapState({

			}),
			wrongs(){
				let qs = this.subjects?.Questions || []
				let answers = this.result?.Detail || []
				let wrongs = []
				for (let answer of answers) {
					for (let q of qs) {
						if (q.Id == answer.QuestionID && answer.IsRight == 0) {
							wrongs.push({
								Title:q.Title,
								Answer:answer.Answer,
								Options:q.Answers,
								QuestionType:q.QuestionType,
							})
							break;
						}
					}
				}
				return wrongs
			}
		},
		methods: {
			...mapActions([
				'getExamResultAction',
				'getELearnExamAction',
			]),
			async initData(){
				let {code,ec} = this.$route.query
				let {result,subjects} = this.getParams()
				if (!result) {
					result = await this.getExamResultAction(code)
				}
				
				this.result = result
				if (!subjects) {
					let response1 = await this.getELearnExamAction({
						ec
					})
					subjects = response1[0]
				}
				this.subjects = subjects

			},
			reWatch(){
				this.$router.push({
					path:'/train/detail',
					query:{
						lessonCode:this.result.LessonCode
					}
				})
			},
			showCer(){
				this.routerPush({
					path:'/train/certificate',
					query:{
						code:this.result.MyCCode
					},
					params:{
						cerUrl:this.result.MyCURL
					}
				})
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.topic {
		@include fontSize($font-size-16);
	}
	.option-title {
		@include fontSize($font-size-16);
	}
	.content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.img {
			width:20.83vw;
			display: block;
			height:auto;
			margin-top: 3vw;
		}
		.title {
			@include fontSize($font-size-24);
			display: flex;
			position: relative;
			align-items: center;
			margin-top: 2.08vw;
			&:after,&:before {
				content: '';
				display: block;
				width: 60px;
				position: absolute;
				border-top: 2px solid black;
			}
			&:before {
				left: -70px;
			}
			&:after {
				right: -70px;
			}
		}
		.detail {
			display: flex;
			margin-top: 3vw;
			div {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 15.63vw;
				.value {
					@include fontSize($font-size-30);
					margin-bottom: 10px;
				}
				.label {
					@include fontSize($font-size-20);
				}
			}
		}
	}
	.wrong-qs {
		margin:0 10.42vw;
		.head {
			color:$theme-color;
			@include fontSize($font-size-24);
			display: flex;
			align-items: center;
			margin-bottom: 30px;
			img {
				width:30px;
				margin-right: 10px;
			}
		}
		.qs {
			color:black;
			@include fontSize($font-size-18);
			margin-bottom: 20px;
			.radio {
				margin: 10px 0;
				display:block;
			}
			.correct {
				span {
					color:$theme-color;
				}
			}
		}
	}
	.bottoms {
		margin: 40px 0;
		display:flex;
		align-items: center;
		justify-content: center;
		.button {
			margin: 0 20px;
			height:60px;
			width:20.83vw;
			min-width: 160px;
			border-radius: 60px;
			@include fontSize($font-size-20);
		}

	}
	.need-lesson {
		margin-top: 20px;
		@include fontSize($font-size-20);
		color: $theme-color;
	}
</style>